export const prepareExtensions = (intent, variables, handleAddVariables, handleAddEquivalences) => {
    if (intent.extensions?.url && !intent.extensions.timeout) {
      intent.extensions.timeout = 15;
    }
    if (intent.extensions.method) {
      intent.extensions.variables = handleAddVariables(variables);
      intent.extensions.equivalences = handleAddEquivalences(variables);
    }
  };
  